import React from "react";
import {Navigate} from "react-router-dom";

// AuthenticationInner pages
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

// login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UsersList from "../pages/Users/Table";
import CustomersList from "../pages/Customers";
import TemplateHistoryPage from "../pages/TemplateHistory";
import RolList from "../pages/Roles/Table";
import CustomerStatesPage from "../pages/CustomerStates";

// Whatsapp
import Whatsapp from "../pages/Whatsapp";

const authProtectedRoutes = [
    //Users
    {path: "/users", component: <UsersList/>},
    //Customers
    {path: "/customers", component: <CustomersList/>},
    //Customer States
    {path: "/customer-states", component: <CustomerStatesPage/>},
    //Template History
    {path: "/template-history", component: <TemplateHistoryPage/>},
    //Roles
    {path: "/roles", component: <RolList/>},
    //Whatsapp
    {path: "/whatsapp", component: <Whatsapp/>},
    {
        path: "/",
        exact: true,
        component: <Navigate to="/customers"/>,
    },
    {path: "*", component: <Navigate to="/customers"/>},
];

const publicRoutes = [
    // Authentication Page
    {path: "/logout", component: <Logout/>},
    {path: "/login", component: <Login/>},
    {path: "/forgot-password", component: <ForgetPasswordPage/>},
    {path: "/register", component: <Register/>},

    // //AuthenticationInner pages
    {path: "/auth-404-basic", component: <Basic404/>},
    {path: "/auth-404-cover", component: <Cover404/>},
    {path: "/auth-404-alt", component: <Alt404/>},
    {path: "/auth-500", component: <Error500/>},

    {path: "/auth-pass-change-basic", component: <BasicPasswCreate/>},
    {path: "/auth-pass-change-cover", component: <CoverPasswCreate/>},
    {path: "/auth-offline", component: <Offlinepage/>},

];

export {authProtectedRoutes, publicRoutes};
